module.exports = __webpack_public_path__ + "media/emoj_chabei.f8ad93ba.ogg";